import { Component, OnInit, Input } from '@angular/core';
import { HeroImageComponent } from './hero-image.component';

@Component({
	selector: 'app-hero-image',
	templateUrl: './hero-image.component.html',
	styleUrls: ['./hero-image.component.scss']
})
export class TAPHeroImageComponent extends HeroImageComponent
	implements OnInit {
	@Input()
	background: string;
	@Input()
	classes: string;

	constructor() {
		super();
	}

	ngOnInit() {}

	TAP_getHeroImageStyles() {
		return this.background;
	}
}
